import { FetchResult, withFetchErrorHandling } from "./resourceTypes";

/**
 * Fetches a URL and returns a blob URL for the content.
 * Useful for CORS workarounds (e.g., VTT subtitles that need to be served from same origin).
 *
 * Note: The caller is responsible for revoking the blob URL when done using URL.revokeObjectURL().
 *
 * @param url - The URL to fetch
 * @param mimeType - The MIME type for the blob (e.g., "text/vtt")
 * @param init - Optional fetch init options
 * @returns FetchResult containing either a blob URL or an error
 */
export async function fetchBlobUrl(url: string, mimeType: string, init?: RequestInit): Promise<FetchResult<string>> {
  return withFetchErrorHandling(
    url,
    "fetchBlobUrl",
    async (response) => {
      const text = await response.text();
      const blob = new Blob([text], { type: mimeType });
      return URL.createObjectURL(blob);
    },
    init,
  );
}
